export default [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/pages/home'),
    meta: {
      pageTitle: 'Applications',
      breadcrumb: [
        {
          text: 'Home',
          active: true,
        },
      ],
      roles: ["user"],
      requireAuth: true,
      logPageName: "Applications",
    },
  },
  /** Admin Users */
  {
    path: '/users',
    name: 'users',
    component: () => import('@/pages/users/list'),
    meta: {
      action: "read",
      pageTitle: 'Users',
      resource: "AdminListUsersRoute",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'List Users',
          active: true,
        }
      ],
      requireAuth: true,
      logPageName: "Admin List Users",
      showPagination: true,
      roles: ["user"],
      permissions: ["users:CanList"]
    },
  },
  {
    name: 'new-user',
    path: '/users/new',
    component: () => import('@/pages/users/new'),
    meta: {
      pageTitle: 'New User',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'List Users',
          to: { name: 'users' },
        },
        {
          text: 'New User',
          active: true,
        },
      ],
      roles: ["user"],
      requireAuth: true,
      permissions: ["users:CanAddNew"],
      logPageName: "Admin Create User",
    },
  },
  {
    name: 'single-user',
    path: '/users/:id',
    component: () => import('@/pages/users/update/admin'),
    meta: {
      pageTitle: 'User Details',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'List Admins',
          to: { name: 'users' },
        },
        {
          text: 'User Details',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      permissions: ["users:CanView"],
      logPageName: "User Details",
    },
  },

  {
    path: '/logs',
    name: 'logs',
    component: () => import('@/pages/logs/list'),
    meta: {
      pageTitle: 'User Logs',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'User Logs',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["logs:CanList"],
      logPageName: "User List Logs",
    },
  },
  {
    path: '/audit-trail',
    name: 'audit-trail',
    component: () => import('@/pages/logs/audit-trail'),
    meta: {
      pageTitle: 'Audit Trail',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Audit Trail',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["audit_trail:CanList"],
      logPageName: "List Audit Trail",
    },
  },


  /** Admin Settings */
  {
    path: '/settings',
    name: 'admin-settings',
    component: () => import('@/pages/settings'),
    meta: {
      pageTitle: 'Settings',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Settings',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      permissions: ["settings:CanView"],
      logPageName: "Admin View Settings",
    },
  },

  /** Admin Church Map */
  {
    path: '/church-map',
    name: 'admin-church-map',
    component: () => import('@/pages/church-map'),
    meta: {
      pageTitle: 'Church Map',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Settings',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["church_map:CanView"],
      logPageName: "Admin View Church Map",
    },
  },
  {
    path: '/policies',
    name: 'admin-policies',
    component: () => import('@/pages/administrations/policies/list-policies'),
    meta: {
      pageTitle: 'Policies',
      breadcrumb: [
        {
          text: 'List Policies',
          to: { name: 'admin-policies' },
        },
        {
          text: 'List',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["policy:CanList"],
      logPageName: "List Policies",
    },
  },
  {
    path: '/policies/:id',
    name: 'admin-view-policies',
    component: () => import('@/pages/administrations/policies/view-policy'),
    meta: {
      pageTitle: 'Policy',
      breadcrumb: [
        {
          text: 'List Policies',
          to: { name: 'admin-policies' },
        },
        {
          text: 'View',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      permissions: ["policy:CanView"],
      logPageName: "View Policies",
    },
  },
  {
    path: '/create-policy',
    name: 'admin-new-policy',
    component: () => import('@/pages/administrations/policies/new-policy'),
    meta: {
      pageTitle: 'Add Policy',
      breadcrumb: [
        {
          text: 'List Policies',
          to: { name: 'admin-policies' },
        },
        {
          text: 'New',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      permissions: ["policy:CanAddNew"],
      logPageName: "Create Policy",
    },
  },
  /** Admin Permission Resource */
  {
    path: '/resources',
    name: 'admin-resources',
    component: () => import('@/pages/administrations/resources/list-resources'),
    meta: {
      pageTitle: 'Resources',
      breadcrumb: [
        {
          text: 'List Resources',
          to: { name: 'admin-resources' },
        },
        {
          text: 'List',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["resource:CanList"],
      logPageName: "List Resources",
    },
  },
  {
    path: '/create-resource',
    name: 'admin-new-resource',
    component: () => import('@/pages/administrations/resources/new-resource'),
    meta: {
      pageTitle: 'Resource',
      breadcrumb: [
        {
          text: 'Resources',
          to: { name: 'admin-resources' },
        },
        {
          text: 'Add Resource',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      logPageName: "New Resources",
      permissions: ["resource:CanAddNew"],
    },
  },
  {
    path: '/update-resource/:id',
    name: 'admin-update-resource',
    component: () => import('@/pages/administrations/resources/update-resource'),
    meta: {
      pageTitle: 'Resource',
      breadcrumb: [
        {
          text: 'Resources',
          to: { name: 'admin-resources' },
        },
        {
          text: 'Update Resource',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      permissions: ["resource:CanView"],
      logPageName: "Update Resources",
    },
  },

  /** Admin Permission Resource Actions */
  {
    path: '/resource-actions',
    name: 'admin-resource-actions',
    component: () => import('@/pages/administrations/resource-actions/list-resource-actions'),
    meta: {
      pageTitle: 'Resource Actions',
      breadcrumb: [
        {
          text: 'List Resource Actions',
          to: { name: 'admin-resource-actions' },
        },
        {
          text: 'List',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["resource_action:CanList"],
      logPageName: "List Resource Actions",
    },
  },
  {
    name: 'admin-new-resource-action',
    path: '/create-resource-action/:id',
    component: () => import('@/pages/administrations/resource-actions/new-resource-action'),
    meta: {
      action: "read",
      pageTitle: 'Add Resource Action',
      resource: "AdminListPermissionsRoute",
      breadcrumb: [
        {
          text: 'Resource Actions',
          to: { name: 'admin-resource-actions' },
        },
        {
          text: 'Add Resource Action',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      logPageName: "Add Resource Actions",
      permissions: ["resource_action:CanView"],
    },
  },
  {
    name: 'admin-update-resource-action',
    path: '/update-resource-action/:id/:resource_id',
    component: () => import('@/pages/administrations/resource-actions/update-resource-action'),
    meta: {
      pageTitle: 'Resource Action',
      breadcrumb: [
        {
          text: 'Resources',
          to: { name: 'admin-resources' },
        },
        {
          text: 'Update Resource Action',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["resource_action:CanView"],
      logPageName: "Update Resource Action",
    },
  },

  /** Admin Permission User Roles */
  {
    path: '/user-roles',
    name: 'admin-user-roles',
    component: () => import('@/pages/administrations/user-roles/list'),
    meta: {
      pageTitle: 'User Role',
      breadcrumb: [
        {
          text: 'List User Roles',
          to: { name: 'admin-user-roles' },
        },
        {
          text: 'List',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["user_role:CanList"],
      logPageName: "List User Roles",
    },
  },
  {
    path: '/user-roles/new',
    name: 'new-user-role',
    component: () => import('@/pages/administrations/user-roles/new-user-role'),
    meta: {
      pageTitle: 'Add User Role',
      breadcrumb: [
        {
          text: 'User Roles',
          to: { name: 'admin-user-roles' },
        },
        {
          text: 'Add User Role',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      logPageName: "Add User Role",
      permissions: ["user_role:CanAddNew"],
    },
  },
  {
    path: '/user-roles/:id',
    name: 'admin-update-user-role',
    component: () => import('@/pages/administrations/user-roles/update-user-role'),
    meta: {
      pageTitle: 'Add Admin User Role',
      breadcrumb: [
        {
          text: 'User Roles',
          to: { name: 'admin-user-roles' },
        },
        {
          text: 'Update Admin User Role',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      permissions: ["user_role:CanView"],
      logPageName: "Update User Role",
    },
  },
  {
    path: '/security-logs',
    name: 'security-logs',
    component: () => import('@/pages/security-logs'),
    meta: {
      pageTitle: "Security Logs",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Security Logs',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      logPageName: "List Security Logs",
    },
  },

  /** Admin Setup (Others) */
  {
    path: '/member-types',
    name: 'member-types',
    component: () => import('@/pages/member-types'),
    meta: {
      pageTitle: "Member Types",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Member Types',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["member_types:CanList"],
      logPageName: "List Member Types",
    },
  },
  {
    path: '/departments',
    name: 'departments',
    component: () => import('@/pages/departments'),
    meta: {
      pageTitle: "Departments",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Departments',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["departments:CanList"],
      logPageName: "List Departments",
    },
  },
  {
    path: '/member-status',
    name: 'member-status',
    component: () => import('@/pages/member-status'),
    meta: {
      pageTitle: "Member Status",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Member Status',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["member_status:CanList"],
      logPageName: "List Member Status",
    },
  },
  {
    path: '/applications',
    name: 'applications',
    component: () => import('@/pages/applications'),
    meta: {
      pageTitle: "Applications",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Applications',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["applications:CanList"],
      logPageName: "List Applications",
    },
  },

  {
    path: '/member-titles',
    name: 'member-titles',
    component: () => import('@/pages/member-titles'),
    meta: {
      pageTitle: "Member Titles",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Member Titles',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["member_titles:CanList"],
      logPageName: "List Member types",
    },
  },

  {
    path: '/member-designations',
    name: 'member-designations',
    component: () => import('@/pages/member-designations'),
    meta: {
      pageTitle: "Member Designation",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Member Designations',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["member_designations:CanList"],
      logPageName: "List Designation",
    },
  },
  {
    path: '/members',
    name: 'members',
    props: {
      ministersOnly: false,
    },
    component: () => import('@/pages/member-profiles'),
    meta: {
      pageTitle: "Members",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Members',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["member_profiles:CanList"],
      logPageName: "List Members",
    },
  },
  {
    path: '/ministers',
    name: 'ministers',
    component: () => import('@/pages/member-profiles'),
    props: {
      ministersOnly: true,
    },
    meta: {
      pageTitle: "Ministers",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Ministers',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["member_profiles:CanList"],
      logPageName: "List Ministers",
    },
  },
  {
    path: '/ministers/:id/edit',
    name: 'ministers-detail',
    component: () => import('@/pages/member-profiles/detail'),
    props: {
      ministersOnly: true,
    },
    meta: {
      pageTitle: "Ministers Edit",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Ministers Edit',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["ministers:CanView"],
      logPageName: "List Ministers",
    },
  },
  {
    path: '/ministers/:id',
    name: 'ministers-view',
    component: () => import('@/pages/member-profiles/show'),
    props: {
      ministersOnly: true,
    },
    meta: {
      pageTitle: "Minister Detail",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Minister Detail',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["ministers:CanView"],
      logPageName: "Ministers Detail",
    },
  },
  {
    path: '/members/:id/edit',
    name: 'members-detail',
    component: () => import('@/pages/member-profiles/detail'),
    meta: {
      pageTitle: "Members",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Members',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["member_profiles:CanView"],
      logPageName: "Members Detail",
    },
  },
  {
    path: '/members/:id',
    name: 'members-view',
    component: () => import('@/pages/member-profiles/show'),
    meta: {
      pageTitle: "Member Detail",
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Member Detail',
          active: true,
        }
      ],
      roles: ["user"],
      requireAuth: true,
      showPagination: true,
      permissions: ["member_profiles:CanView"],
      logPageName: "Members Detail",
    },
  },

  // Sample CSV
  {
    path: '/import-reports',
    name: 'import-reports',
    component: () => import('@/pages/import-reports/list'),
    meta: {
      pageTitle: 'Data Import Reports',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Data Import Reports',
          active: true,
        }
      ],
      requireAuth: true,
      roles: ["user"],
      showPagination: true,
      permissions: ["csv_upload_data:CanList"],
      logPageName: "List Data Import",
    },
  },
  {
    path: '/import-reports/:id',
    name: 'import-reports-detail',
    component: () => import('@/pages/import-reports/view'),
    meta: {
      pageTitle: 'Data Import Report',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Data Import Report',
          active: true,
        }
      ],
      requireAuth: true,
      roles: ["user"],
      showPagination: true,
      permissions: ["csv_upload_data:CanView"],
      logPageName: "View Data Import",
    },
  },
  {
    path: '/sample-csv-files',
    name: 'admin-sample-csv-files',
    component: () => import('@/pages/sample-csv-files/list'),
    meta: {
      pageTitle: 'Sample CSV Files',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Sample CSV Files',
          active: true,
        }
      ],
      requireAuth: true,
      roles: ["user"],
      showPagination: true,
      permissions: ["sample_csv_files:CanList"],
      logPageName: "List Sample CSV Files",
    },
  },
  {
    path: '/sample-csv-files/new',
    name: 'admin-new-sample-csv-file',
    component: () => import('@/pages/sample-csv-files/new'),
    meta: {
      pageTitle: 'New Sample CSV File',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'List Sample CSV Files',
          to: { name: 'admin-sample-csv-files' },
        },
        {
          text: 'New Sample CSV File',
          active: true,
        }
      ],
      requireAuth: true,
      roles: ["user"],
      permissions: ["sample_csv_files:CanAddNew"],
      logPageName: "Create Sample CSV File",
    },
  },
  {
    path: '/sample-csv-files/:id/update',
    name: 'admin-update-sample-csv-file',
    component: () => import('@/pages/sample-csv-files/update'),
    meta: {
      pageTitle: 'Update Sample CSV File',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'List Sample CSV Files',
          to: { name: 'admin-sample-csv-files' },
        },
        {
          text: 'Update Sample CSV File',
          active: true,
        }
      ],
      requireAuth: true,
      roles: ["user"],
      permissions: ["sample_csv_files:CanView"],
      logPageName: "Update Sample CSV File",
    },
  },
  {
    path: '/geo/areas',
    name: 'areas',
    component: () => import('@/pages/areas'),
    meta: {
      pageTitle: 'Areas',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Areas',
          active: true,
        }
      ],
      requireAuth: true,
      roles: ["user"],
      showPagination: true,
      permissions: ["areas:CanList"],
      logPageName: "List Areas",
    },
  },
  {
    path: '/geo/districts',
    name: 'districts',
    component: () => import('@/pages/districts'),
    meta: {
      pageTitle: 'Districts',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Districts',
          active: true,
        }
      ],
      requireAuth: true,
      roles: ["user"],
      showPagination: true,
      permissions: ["districts:CanList"],
      logPageName: "List Districts",
    },
  },
  {
    path: '/geo/assemblies',
    name: 'assemblies',
    component: () => import('@/pages/assemblies'),
    meta: {
      pageTitle: 'Assemblies',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Assemblies',
          active: true,
        }
      ],
      requireAuth: true,
      roles: ["user"],
      showPagination: true,
      permissions: ["assemblies:CanList"],
      logPageName: "List assemblies",
    },
  },
  {
    path: '/geo/regions',
    name: 'regions',
    component: () => import('@/pages/regions'),
    meta: {
      pageTitle: 'Regions',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'Regions',
          active: true,
        }
      ],
      requireAuth: true,
      roles: ["user"],
      showPagination: true,
      permissions: ["regions:CanList"],
      logPageName: "List regions",
    },
  },

  // Geo routes
]
